var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.clearCash.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('clear_cache')))])
}
var staticRenderFns = []

export { render, staticRenderFns }